import { render, staticRenderFns } from "./ImpersonationStatus.vue?vue&type=template&id=b0f68866&"
import script from "./ImpersonationStatus.vue?vue&type=script&lang=js&"
export * from "./ImpersonationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports